import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Button } from '@netbasequid/core'
import { Theme, Page } from 'features/ui/types'
import { useDisplayTheme, usePage } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'

interface AnnotationButtonProps {
  onClick: () => void
  disabled?: boolean
}

const AnnotationButton = ({ onClick, disabled }: AnnotationButtonProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const page = usePage()

  if (page === Page.LiveReport) {
    return null
  }
  return (
    <Button
      data-testid={AutomationId.insightModal.annotationButton}
      mode={theme}
      color="secondary"
      onClick={onClick}
      disabled={disabled}>
      {t('annotation')}
    </Button>
  )
}

export default AnnotationButton
